import { apiClient } from './ApiClient';

type IoTJobStatus = {
  status: string;
  lastUpdatedAt: string;
  isCancellable: boolean;
};
type IoTJobStatusInput = {
  jobId: string;
  canopyDeviceId: string;
};
type CancelIoTJobResponse = {
  status: string;
  message: string;
};

export const getIoTJobStatus = async (
  params: IoTJobStatusInput,
): Promise<IoTJobStatus> => {
  const response = await apiClient
    .getClient()
    .get(`jobs/${params.jobId}/device/${params.canopyDeviceId}`);
  return response.data;
};

export const cancelIoTJob = async (
  params: IoTJobStatusInput,
): Promise<CancelIoTJobResponse> => {
  const response = await apiClient
    .getClient()
    .post(`jobs/${params.jobId}/device/${params.canopyDeviceId}/cancel`);
  return response.data;
};
